import React from 'react'
import {BrowserRouter as Router , Route , Switch} from 'react-router-dom'
import {About, Contact, Courses, Expert, Home , NotFound, Training} from '../pages'
import {Footer, Header} from '../component/layout'
import { ScrollTop } from '../component/fiture'

function index() {
    return (
        <Router>
            <div>
                <ScrollTop />
                <Header />
                
                <Switch>
                    <Route path='/' exact component={Home}/>
                    <Route path='/about' exact component={About}/>
                    <Route path='/courses' exact component={Courses}/>
                    <Route path='/experts' exact component={Expert}/>
                    <Route path='/get-in-touch' exact component={Contact}/>
                    <Route path='/training' exact component={Training}/>
                    <Route path='**' component={NotFound} />

                </Switch>

                <Footer />
            </div>
        </Router>
    )
}

export default index
